import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import UsuarioProdutoForm from '../components/UsuarioProdutoForm';
import { getTemPermissao, getTipoUsuario } from "../utils/LoginManager";
import numeral from "numeral";

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
  };

  componentDidMount() {
    getTipoUsuario().then(tipoUsuario => {
      this.setState({
        tipoUsuario,
      },
        this.getListaRegistros()
      );
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true, });
    const { busca, pagina, limite } = this.state;
    axios
      .get('/usuarios_produtos', {
        params: {
          page: pagina,
          limite: limite,
          buscaDescricao: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.up_idf) {
      request = axios.put(`/usuarios_produtos/update/${registro.up_idf}`, registro);
    } else {
      request = axios.post(`/usuarios_produtos/store`, registro)
    }

    request
      .then(response => {
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Registro gravado com sucesso.');
        this.getListaRegistros();
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }


  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/usuarios_produtos/show/${registro.up_idf}`)
      .then(response => {
        const { data } = response;

        data.up_usuario = {
          key: data.up_usuario || '0',
          label: data.usu_nome || '',
        };

        data.up_grupo = data.up_grupo
          ? {
            key: data.up_grupo,
            label: data.grp_descricao,
          }
          : { key: '0' };

        data.up_item = data.up_item
          ? {
            key: data.up_item,
            label: data.prod_descricao,
          }
          : { key: '0' };

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/usuarios_produtos/delete/${registro.up_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.up_idf === registro.up_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
          })
      }
    })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        up_usuario: { key: '0' },
        up_grupo: { key: '0' },
        up_item: { key: '0' },
      }
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }


  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };



  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {/* <Tooltip title="Editar" placement="left">
          <Button className="botoesModalFormEditar" disabled={getTemPermissao('UsuariosProdutosPage', 'editar') ? false : true} size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
        </Tooltip> */}
        <Tooltip title="Excluir" placement="right">
          <Button className="botoesModalFormExcluir" disabled={getTemPermissao('UsuariosProdutosPage', 'excluir') ? false : true} size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite, busca, flagBuscaUsuario } = this.state;

    // console.log('UsuariosProdutosPage: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <div>
          <h2 className="tituloPage">Produtos dos Vendedroes</h2>
          <hr />
          <br />

          <div className="pageFiltro">
            {(!this.state.tipoUsuario) || (getTemPermissao('UsuariosProdutosPage', 'novo')) ? (
              <Button
                onClick={this.onAdicionarClick}
                className="pageFiltro-adicionar"
              >
                Adicionar
              </Button>
            ) : null}

            <Search
              placeholder="Buscar por Nome"
              onSearch={this.onBuscar}
              enterButton
              className="pageFiltro-busca"
            />

            <UsuarioProdutoForm
              visivel={formVisivel}
              onSalvarClick={this.onSalvarClick}
              onCancelarClick={this.onCancelarClick}
              carregando={salvando}
              registroSelecionado={registroSelecionado}
            />

          </div>

          <br />

          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            // scroll={{ x: 600 }}
            rowKey={(registro => registro.up_idf)}
          >
            <Column
              key="usu_nome"
              dataIndex="usu_nome"
              title="Vendedor"
              width={"30%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="grp_descricao"
              dataIndex="grp_descricao"
              title="Grupo Produto"
              width={"30%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="prod_descricao"
              dataIndex="prod_descricao"
              title="Produto"
              width={"30%"}
              align="left"
              className="listaCadastro"
            />
            {getTemPermissao('UsuariosProdutosPage', 'editar') || getTemPermissao('UsuariosProdutosPage', 'excluir') ? (
              <Column
                key="acoes"
                title="Ações"
                render={this.renderAcoes}
                width={"10%"}
                align="center"
                className="listaCadastro"
              />
            ) : null}
          </Table>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/UsuariosProdutosPage.js